import { PageNotFoundIllustration } from '@/assets/illustrations';

import Container from '@mui/material/Container';

export default function NotFoundPage() {
  return (
    <Container maxWidth="sm" style={{ marginTop: '40px' }}>
      <PageNotFoundIllustration />
    </Container>
  );
}
